<template>
  <div class='interview_wrapper'>
    <step-status :step="$route.meta.step" class="mt55"></step-status>

    <h1 v-if='$route.query.status=="Reschedule"'>
      Hi {{full_name}},<br />
      Thank you for your application to teach with HAWO!<br /> We’ve received your information and requested interview time.<br /> Below, please find the confirmation for your interview, and some further information regarding our interview and demo process.</h1>

    <h1 v-if='$route.query.status=="Schedule"'>Dear {{full_name}},we've assigned an interviewer for you, please click the "Schedule" button below to book an appointment with your interviewer.</h1>

    <h1 v-if='$route.query.status=="canceled"'>Dear {{full_name}}, you've cancelled your scheduled interview time. You may request a new appointment.</h1>

    <!-- <h1 v-if='$route.query.status=="no_show"'>Dear {{full_name}}, we didn’t catch you at your scheduled interview time, so we had to cancel the appointment. You may request a new appointment.</h1> -->

    <h1 v-if='$route.query.status=="rescheduled"'>Hi {{full_name}}, your interview appointment has been rescheduled .</h1>

    <div class="schedule">
      <h4>Your Interview Schedule</h4>
      <div class='schedule_de clearfix'>
        <div class="left">
          <ul>
            <li class='clearfix'>
              <span class='schedule_de_tit'>Time Zone：</span>
              <p>{{time_zone}}</p>
            </li>
            <li class='clearfix'>
              <span class='schedule_de_tit'>Date & Time：</span>
              <p>{{interviewer_date}}</p>
            </li>
            <li class='clearfix'>
              <span class='schedule_de_tit'>Interviewer：</span>
              <div>
                <p>{{interviewer_name}}</p>
                <p v-show='interviewer_zoom'>Zoom account : {{interviewer_zoom}}</p>
                <p v-show='interviewer_email'>Email : {{interviewer_email}}</p>
              </div>
            </li>
            <li class='clearfix'>
              <span class='schedule_de_tit'>Where：</span>
              <p>Your interview will be conducted on Zoom.</p>
              <p class="interview_click">
                <a target="_blank" :href="urls.zoomPdfLink" download="zoom.pdf">Click here</a>
                <span>to download Zoom.</span>
              </p>
              <p class="interview_click">Please check your email inbox or spam folder for further instructions from your recruiter.</p>
            </li>
          </ul>
        </div>
        <div class="right">
          <el-tooltip class="item" effect="dark" content="Kindly contact your recruiter since you've already rescheduled/cancelled once." placement="right" :disabled="canReschedule">
            <a class='style reschedule' :class="{dis: !canReschedule}" @click='showPop'>{{reschedule_inner}}</a>
          </el-tooltip>

          <el-tooltip class="item" effect="dark" content="Kindly contact your recruiter since you've already rescheduled/cancelled once." placement="right" v-if="interviewer_date" :disabled="canReschedule">
            <a class='style cancel' :class="{dis: !canReschedule}" @click='cancel_apo'>Cancel Appointment</a>
          </el-tooltip>

          <a class='need_help' v-if="need_help" :href='`mailto:${need_help}`'>Have questions? Email here</a>
        </div>
      </div>
    </div>

    <div class="preparation">
      <h4>Interview details</h4>
      <div class="preparation_de">
        <p>Interview (20 minutes): The interview gives us a chance to learn more about you and your teaching experience.</p>
        <p>Demo class (15 minutes): The demo class gives us a chance to observe your teaching abilities. You should be prepared to teach a lesson to your interviewer, as if he or she is a 5 years old student.</p>
        <p>If you have any questions regarding your interview or demo, please feel free to contact your interviewer directly via email <a :href="`mailto:${interviewer_email}`">{{interviewer_email}}</a><template v-if="interviewer_zoom"> or Zoom (live: {{interviewer_zoom}})</template>. </p>
      </div>
    </div>

    <div class="preparation">
      <h4>Material and Preparations:</h4>
      <div class="preparation_de">
        <p>Click <a target="_blank" :href="urls.interviewPdfLink" download="nademomaterial_20180818.pdf">here</a> to download the lesson material that you’ll be teaching in your demo class. If you cannot access the previous link, copy the following link into your browser: </p>
        <p>http:{{urls.interviewPdfLink}}</p>
        <div>
          <h4>Demo tips</h4>
          <ul>
            <li>The provided demo material is structured for a typical 25-minute class. You should teach it as if your demo class were to last for 25 minutes, although your interviewer will stop you early.</li>
            <li>As this interview is for an online teaching position, please be prepared with a clutter-free space, proper lighting,professional attire, and proper positioning in the center of the camera.</li>
            <li>Your interviewer will have the same lesson material on hand.</li>
            <li>Remember: you’ll be teaching kids, so be happy, engaging, and excited. Putting on a smile goes a long way! Incorporating helpful body language and gestures into your lesson is key for communicating with students who have little knowledge of English.</li>
            <li>Have fun! Keeping your lesson entertaining and interesting helps students learn quickly.</li>
          </ul>
        </div>
      </div>
      <img src="~@img/KEOT.jpg" alt="">
    </div>
    <div class="pop" v-show='reschedule_show'>
      <reschedule :time-zone='options' :scheduled-time-zone="time_zone" :scheduled-interviewer-date="interviewer_origin_date" :interviewer-id='interviewer' :sureHandler='confirmOpen'></reschedule>
    </div>
    <cancel-confirm ref="cancelConfirm"></cancel-confirm>
    <img src="//www.jobs2careers.com/conversion3.php?p=3857" width="1" height="1" />
    <!-- Google pixel -->
    <div style="display:inline;" v-if='$route.query.status=="assigned"'>
      <img height="1" width="1" style="border-style:none;" alt="" src="//www.googleadservices.com/pagead/conversion/852175291/?label=dFR5CIzryngQu9OslgM&amp;guid=ON&amp;script=0" />
    </div>
  </div>
</template>
<script>
import reschedule from './reschedule.vue'
import CancelConfirm from '../other/CancelConfirm.vue'
import { urls } from '@js'

export default {
  props: {},
  data() {
    return {
      time_zone: '',
      t_id: '',
      interviewer_date: '',
      interviewer_origin_date: '',
      interviewer_name: '',
      interviewer_zoom: '',
      interviewer_email: '',
      options: '',
      need_help: '',
      interviewer: '',
      assigned: false,
      canceled: false,
      no_show: false,
      reschedule: false,
      full_name: '',
      reschedule_inner: '',
      reschedule_show1: false,
      reschedule_show2: false,
      canReschedule: false,
      urls
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      //获取search值判断文案显示
      vm.reschedule_show1 = false
      let url = location.href
      let urlStatus
      urlStatus = url.split('=')[1]
      console.log(urlStatus)
      if (urlStatus == 'canceled') {
        vm.canceled = true
        vm.reschedule_inner = 'Reschedule'
      } else if (urlStatus == 'no_show') {
        vm.$router.replace('/interview_result?status=noshow')
        // vm.no_show = true
        // vm.reschedule_inner = 'Reschedule'
      } else if (urlStatus == 'rescheduled') {
        vm.reschedule_show1 = false
        vm.reschedule = true
        vm.reschedule_inner = 'Reschedule'
      }

      vm.$http.get('/common/getConfig?key=time_zone').then(function(d) {
        if (d.data.code == '75000') {
          this.options = d.data.res.time_zone //获取时区传给子组件
        }
      })

      vm.$http.get('/interview/getTutorProfile?type=interview').then(
        function(d) {
          if (d.data.code == '75000') {
            var arrDate = d.data.res.tutor //保存返回信息渲染页面
            // 是否可以重新预约
            vm.canReschedule = arrDate.reschedule_status == 1
            //need help 变量替换
            vm.need_help = arrDate.interviewer_info.interviewer_email
            vm.interviewer_date = arrDate.interviewer_date
            vm.interviewer_origin_date = arrDate.interviewer_origin_date
            vm.interviewer_name = arrDate.interviewer_info.interviewer_name
            vm.interviewer_zoom = arrDate.interviewer_info.interviewer_zoom
            vm.interviewer_email = arrDate.interviewer_info.interviewer_email
            vm.full_name = arrDate.full_name
            vm.interviewer = arrDate.interviewer //记录面试老师ID
            vm.time_zone = arrDate.appoint_time_zone
            vm.t_id = arrDate.t_id

            if (urlStatus == 'assigned') {
              if (vm.interviewer_date == '') {
                vm.reschedule_inner = 'Schedule'
                vm.$route.query.status = 'Schedule'
              } else {
                vm.reschedule_inner = 'Reschedule'
                vm.$route.query.status = 'Reschedule'
              }
            }
          }
        },
        function() {
          console.log('service error')
        }
      )
    })
  },
  methods: {
    showPop() {
      if (!this.canReschedule) return
      this.$store.commit('reschedule_pop_show')
    },
    async cancel_apo() {
      if (!this.canReschedule) return

      const { remark } = await this.confirmOpen({
        type: 'cancel'
      })

      this.$http.get(`/interview/cancelInterview?t_id=${this.t_id}&remark=${remark}`).then(d => {
        if (d.data.res == '75000') {
          this.$message.success('Success!')
          window.location.reload()
        } else {
          this.$message.error(d.data.message)
        }
      })
    },
    confirmOpen(data) {
      return this.$refs.cancelConfirm.open(data)
    }
  },
  components: {
    reschedule,
    CancelConfirm
  },
  computed: {
    reschedule_show() {
      return this.$store.state.pop_up
    }
  }
}
</script>
<style lang='less' scoped>
.interview_wrapper {
  width: 1000px;
  margin: 0 auto;
  & > img {
    margin-top: 55px;
  }
  & > h1 {
    font-size: 16px;
    color: #1e1e1e;
    font-weight: bold;
    margin-top: 55px;
    line-height: 1.4;
  }
  .schedule {
    padding-top: 44px;
    & > h4 {
      font-size: 24px;
      color: #febf00;
    }
    .schedule_de {
      margin-top: 29px;
      background: #f7f7f7;
      padding: 40px 30px;
      border-radius: 10px;
      .left {
        float: left;
        width: 706px;
        border-right: 1px solid #e0e0e0;
        font-size: 14px;
        border-radius: 10px;
        & > h4 {
          font-size: 14px;
          color: #1e1e1e;
          font-weight: bold;
        }
        & > ul {
          li {
            padding-top: 24px;
            line-height: 18px;
            * {
              float: left;
            }
            div {
              height: 65px;
            }
            p {
              color: #1e1e1e;
              float: none;
            }
            .schedule_de_tit {
              color: #999;
              width: 100px;
              vertical-align: top;
            }
          }
        }
        .interview_click {
          padding-left: 100px;
          line-height: 20px;
          height: 20px;
          span {
            text-indent: 10px;
          }
          a {
            color: #009cff;
            text-decoration: underline;
          }
        }
      }
      .right {
        float: left;
        width: 230px;
        a {
          cursor: pointer;
          display: block;
        }
        a:nth-child(1) {
          margin-top: 28px;
        }
        .style {
          width: 152px;
          height: 40px;
          line-height: 40px;
          text-align: center;
          border: 1px solid #fcc800;
          border-radius: 10px;
          color: #febf00;
          background: #fbfcfc;
          margin: 0 auto 20px;
        }
        .style {
          width: 152px;
          height: 40px;
          line-height: 40px;
          font-size: 14px;
          text-align: center;
          border: 1px solid #fcc800;
          border-radius: 10px;
          color: #febf00;
          background: #fbfcfc;
        }
        .dis {
          cursor: not-allowed;
          color: #666;
          border-color: #ccc;
          background: #f3f3f3;
        }
        .need_help {
          font-size: 13px;
          text-decoration: underline;
          color: #1e1e1e;
          text-align: center;
          display: block;
        }
      }
    }
  }
  .preparation {
    padding-top: 44px;
    margin-bottom: 40px;
    & > h4 {
      font-size: 24px;
      color: #febf00;
    }
    .preparation_de {
      margin-top: 29px;
      background: #f7f7f7;
      padding: 40px 30px;
      border-radius: 10px;
      font-size: 14px;
      color: #1e1e1e;
      a {
        color: #009cff;
      }
      & > p {
        padding-bottom: 14px;
      }
      & > a {
        display: inline-block;
        color: #009cff;
        padding-bottom: 30px;
        text-decoration: underline;
      }
      & > div {
        h4 {
          font-weight: bold;
        }
        ul {
          margin-top: 16px;
          li {
            padding-bottom: 20px;
            margin-left: 20px;
            list-style: disc outside;
          }
        }
      }
    }
    & > img {
      width: 1000px;
    }
  }
}
</style>
<style lang="less">
.mes-tip {
  width: 600px;

  .el-message-box__message {
    p {
      margin-bottom: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// interview.vue?145cfe61